import RegisterSwitch from './RegisterSwitch';
import './style/index.less';

export default RegisterSwitch;
